import { render, staticRenderFns } from "./StepOneSMS.vue?vue&type=template&id=a0b86090&lang=pug"
import script from "./StepOneSMS.vue?vue&type=script&lang=ts"
export * from "./StepOneSMS.vue?vue&type=script&lang=ts"
import style0 from "./StepOneSMS.vue?vue&type=style&index=0&id=a0b86090&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports